import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'YardiTheme',
  code: 'yardi',
  colors: {
    headerBackground: '#ffffff',
    headerText: '#202020',
    headerBorder: '#0072CE',
    background: '#ffffff',
    footerBackground: '#f5f7fa',
    footerText: '#595959',
    footerBorder: '#e6e6e6',
    progressBar: '#0072CE',
  },
  logoSize: {
    width: '168px',
    height: '40px',
  },
  baseColors: {
    link: '#0072CE',
    cta: '#0072CE',
    hover: '#005fa3',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const YardiTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
